<template>
    <div grey-back full-height>

        <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

        <dialog-form ref="ref_dialogForm" :closeDialog="fn_closeDialogForm"></dialog-form>
    </div>
</template>

<script>

// const systemLists = require('../../../../../config.js').configs.mastersPredefinedLists;

import dialogForm from './dialogs/dialog_form'

// import dialogDraftItems from '../../../../dialogs/dialog_draft_items'

    export default{
        // mixins: [draftMixin],
        data(){
            return{
                Form:{"description":null, "groupTypeId":801, "listId":null, "listItemsId":null, "name":null, "title":null, "listTitle":null, "isSystem":0, "draftItems":[], "createdDate":null, "modifiedDate":null, 
                "additionalData":{
                        "prescribeDetails":{'regNumber':null, 'mobileNumber':null, 'address':null},
                        "referenceDetails":{'mobileNumber':null, 'address':null}
                    }
                },
                loading:false,
                tagId:null,
                draftStorageId:null,
                snackbar:false,
                snackbar_msg:null,

                unwatch:false,
                // loadedFromDraft:false,
                backButtonPress:false,
                nextRoute:{"path":null, "query":null},
                disableOnSave:false
            }
        },
        // watch:{
        //  'Form': {
  //               handler: function (newVal, oldVal){
  //                    // this.fn_saveToLocalStorage(this);
  //                    if(!this.unwatch){
  //                        this.fn_saveDraft(this.Form.name);
  //                    }
  //                    this.unwatch = false;
  //                },
  //                deep: true
  //           }
        // },
        components:{
            // 'dialog-discard': dialogDiscard,
            'dialog-form':dialogForm
            // 'dialog-draft-items': dialogDraftItems
        },
        methods:{

            fn_closeDialogForm: function(){
                this.fn_goBack();
            },

            // fn_openDialogDiscard: function(){
            //  this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
            // },

            // fn_openDialogWeb: function (platform, name, ref) {

            //  let scroll_y = window.scrollY;
            //  this.fn_fixBackgroundScroll();

            //  var tagId = this.guidWeb();

            //  var dialogObj = {};
            //  dialogObj.tagId = tagId;
            //  dialogObj.formId = this.formId;
            //  dialogObj.name = name;
            //  dialogObj.ref = ref;
            //  dialogObj.data = null;
            //  dialogObj.platform = platform;

            //  dialogObj.scrollPosition = {};
            //  dialogObj.scrollPosition.x = 0;
            //  dialogObj.scrollPosition.y = scroll_y;

            //  dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

            //  this.$refs[ref].openDialogWeb();
            // },

            // fn_closeDialog: function (tagId) {
            //  dialogjs.fn_checkAndCloseOpenDialogs(this);
            // },

            checkEnter: function(event){
                if (event.keyCode == 13) {
                   return false;
               }
            },

            // fn_getBottomMenu: function (tagId) {
            //  var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
            //  this.setBottomMenu(tagId, bottomMenu, 
            //      {
            //          onSuccess: function (response) {
            //              console.log(response);
            //          },
            //          onError: function (error) {
            //              console.log(error);
            //          }
            //      }
            //  )
            // },

            fn_checkValidations: function(){
                // var self = this;
             //    this.$validator.validateAll().then((result) => {
             //        if (result) {
             //           self.fn_post();   
             //             return; 
             //        }
             //        else{
             //         this.$vuetify.goTo('.error--text', this.scrollOptions);
             //        }
             //        self.loading = false;
             //    });
                this.fn_post();
            },

            fn_saveLocal: function(dataObj){
                var self = this;
                this.postData('ListItem', dataObj, 
                    {
                        onSuccess: function(response){
                          console.log(response);
                          let status = JSON.parse(response);
                          if(status) {
                            self.fn_cleanUp();
                          }
                          else {
                            self.disableOnSave = false;
                            self.saveBtnKey++;
                            self.$eventHub.$emit('snackbarAlert', {msg:'Already exists with this name'});
                          }
                        },
                        onError: function(error){
                            self.disableOnSave = false;
                            self.saveBtnKey++;
                            console.log(error);
                        }
                    }
                );
            },

            fn_cleanUp: function () {

                // this.loadedFromDraft = false;

                if(this.$route.query.ls){
                    let data = {};

                    data.type = this.$route.query.type ? this.$route.query.type : 'listItem';
                    data.id = this.Form.listItemsId;
                    data.name = this.Form.name;
                    localStorage.setItem('newItem', JSON.stringify(data));
                    // localStorage.setItem('closeDialog', 1);
                }

                this.$eventHub.$emit('UpdateListItem', {});
                this.fn_goBack();

                // let self = this;
                // this.fn_removeDraft(this.draftStorageId, function(){

                //  if(localStorage.getItem("master_items_state")){
                //      let obj = JSON.parse(localStorage.getItem("master_items_state"));
                //      obj.itemId = self.Form.listItemsId;
                //      localStorage.setItem("master_items_state",JSON.stringify(obj));
                //  }

                //  self.$router.go(-1);
                // });
                
            },

            fn_post: function(){
                // !this.Form.listItemsId ? this.Form.listItemsId = this.guid() : '';
                if(!this.Form.listItemsId){
                    this.Form.listItemsId = this.guid();
                    // this.Form.createdDate = new Date();
                    this.Form.createdDate = this.$root.fn_getLocalDateFormat();
                }

                // this.Form.modifiedDate = new Date();
                this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();
                this.Form.name = this.Form.name.trim();
                this.$route.query && this.$route.query.listId ? this.Form.listId = this.$route.query.listId : '';
                console.log(this.Form);
                if(this.$route.query.listId == 'prescribe_by_details'){
					this.Form.additionalData.prescribeDetails.name = this.Form.name;
				}
                if(this.$route.params.listId == 'referred_by_details'){
					this.Form.additionalData.referenceDetails.name = this.Form.name;
				}
                this.fn_saveLocal(this.Form);
            },

            fn_get: function(itemId, copyData){
                var self = this;
                this.getData('ListItem', itemId, 
                    {
                        onSuccess: function(response){
                          console.log(self.Form);
                          self.unwatch = true;
                          self.Form = JSON.parse(response);
                          self.Form.additionalData = JSON.parse(self.Form.additionalData);

                            if(copyData){
                                self.Form.listItemsId=null;
                                self.Form.isSystem = 0;
                                // alert("List Item copied");
                                self.$eventHub.$emit('snackbarAlert', {msg:'List Item copied'});
                            }

                            self.$root.fn_copyFormObject(self.Form, self.formId);
                        }, 
                        onError: function(error){
                          console.log(error);
                        }
                    }
                );
            },

            fn_clearForm: function(){
                this.Form = {"description":null, "groupTypeId":801, "listId":null, "listItemsId":null, "name":null, "title":null, "listTitle":null, "isSystem":0, "draftItems":[], "createdDate":null, "modifiedDate":null};
                this.$validator.reset();
            },

            // fn_saveToLocalStorage: function(){
            //  if(!this.unwatch){
            //      var dataObj = {};
            //      dataObj.type = "List Item";
            //      dataObj.formType = "new";
            //      dataObj.modifiedDate = new Date();
            //      dataObj.formId = this.formId;
            //      dataObj.draftId = this.draftStorageId;
            //      dataObj.uri = this.$route.path;
            //      dataObj.dataModel = this.Form;
            //      dataObj.dataModel.listTitle = this.$route.query.listTitle;
            //      localStorage.setItem(this.draftStorageId, JSON.stringify(dataObj));
            //  }
            //  this.unwatch = false;
                
            // },

            // fn_menuItemClick: function(tagId, menuId, menuAction){
            //  // tagId id form future use
            //  // menuId id form future use

            //  this.backButtonPress = false;
                
            //  if(menuAction=='save'){
            //      this.fn_checkValidations();
            //  }
            //  else if(menuAction=='reset'){
            //      this.fn_resetForm();
            //  }
            // },

            // fn_resetForm: function () {
            //  this.unwatch = true;
            //  // this.loadedFromDraft = false;

            //  if(this.Form.listItemsId){
            //      this.fn_get(this.Form.listItemsId);
            //  }
            //  else{
            //      this.fn_clearForm();
            //  }
                
            //  // if(localStorage.getItem(this.draftStorageId)){
            //  //  localStorage.removeItem(this.draftStorageId);
            //  //  this.snackbar = true;
            //  //  this.snackbar_msg = "Item deleted from draft";
            //  // }

            //  let self = this;
            //  this.fn_removeDraft(this.draftStorageId, function(){
            //      console.log("draft deleted");
            //      // self.showToast("Item deleted from draft");
            //  });
            // },

            // fn_showWebView: function () {
            //  var viewObject = {};
            //  viewObject.ToolbarTitle = this.$route.query.listTitle;
            //  viewObject.TopMenu = [menuItem.save];
            //  viewObject.isBottomMenu = true;
            //  // viewObject.BottomMenu = [{"MenuID":2, "MenuType":null, "Icon":"save", "Text":"Save", "Action": "save"}]
            //  var tagId = this.formId;
            //  var self = this;
            //  this.showWebView(tagId, viewObject, 
            //      {
            //          onSuccess: function(response){
            //            console.log(response);
            //          }, 
            //          onError: function(error){
            //            console.log(error);
            //          }, 
            //          // onChange: null,
            //          onMenuItemClick: function (tagId, menuId, menuAction) {
            //              self.fn_menuItemClick(tagId, menuId, menuAction)
            //          }
            //      }
            //  );
            // },

            // fn_setFormDataFromLocalStorage: function () {
            //  if(localStorage.getItem(this.draftStorageId)){
            //      var formData = JSON.parse(localStorage.getItem(this.draftStorageId));
            //      this.Form = formData.dataModel;

            //      if((this.$route.query && this.$route.query.draft) || (this.$route.params && this.$route.params.tagId)){
            //          this.loadedFromDraft = true;
            //      }
            //  } 
            // },

            // fn_goBack: function(){
            //     this.backButtonPress = true;
            //     this.$router.go(-1);
            // }
            fn_goBack: function(){
                this.$root.viaKeyboardShortCut = false;
                this.$refs['ref_dialogForm'].closeDialogWeb();
                this.backButtonPress = true;
                setTimeout(() => {
                    if(this.nextRoute.path){
                        this.nextRoute.query ? this.$router.replace({path:this.nextRoute.path, query:this.nextRoute.query}) : this.$router.replace({path:this.nextRoute.path});
                    }
                    else{
                        this.$router.go(-1);
                    }
                }, 50);
            }
        },
        mounted: function(){

            // var self = this;

            // this.Form.listTitle = this.$route.query.listTitle;
            // this.Form.listId = this.$route.params.listId;

            if(this.$route.query && this.$route.query.tagId){//in case of new form
                this.formId = this.$route.query.tagId;
                // this.draftStorageId = 'draft_master_'+this.formId;
                // this.dialogStorageId = 'dialog_'+this.formId;
            }
            else if(this.$route.params && this.$route.params.tagId){//in case of edit form
                this.formId = this.$route.params.tagId;
                // this.draftStorageId = 'draft_master_'+this.formId;
                // this.dialogStorageId = 'dialog_'+this.formId;
            }

            this.$refs['ref_dialogForm'].openDialogWeb();

            this.$eventHub.$on('save', () => {
                this.$refs['ref_dialogForm'].fn_validateForm();
            });

            this.$eventHub.$on('escape', () => {
                this.fn_closeDialogForm();
            });

        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                // vm.enableToolbar();
                
                let itemId = null;
                let copyData = false;

                // to.query && to.query.copy && from.name == 'itemlist' ? copyData = true : '';
                to.query && to.query.copy ? copyData = true : '';

                // if(to.query && to.query.itemId && from.name == 'itemlist'){
                //     itemId = to.query.itemId;
                // }
                if(to.query && to.query.itemId){
                    itemId = to.query.itemId;
                }

                if(to.params && to.params.tagId){//from display view
                    itemId = to.params.tagId;
                }

                if(itemId){
                    vm.fn_get(itemId, copyData);
                }
                else{
                    vm.$root.fn_copyFormObject(vm.Form, vm.formId);                 
                }

                let isCalled = false;
                vm.$eventHub.$on('connected', () => {
                    setTimeout(() => {
                        if(!isCalled){
                            isCalled = true;
                            vm.disableOnSave = false;
                            vm.saveBtnKey++;
                            itemId ? vm.fn_get(itemId, copyData) : '';
                        }

                        setTimeout(() => {
                            isCalled = false;
                        }, 3000);
                    }, 1000);
                });
            })
        },
        beforeRouteLeave (to, from, next) {
            if(this.$root.viaKeyboardShortCut){
                this.nextRoute.path = to.path;
                this.nextRoute.query = to.query;
                this.fn_closeDialogForm();
            }
            else{
                this.nextRoute.path = null;
                this.nextRoute.query = null;
                this.$eventHub.$off('save');
                this.$eventHub.$off('escape');
                this.$eventHub.$off('connected');
                next();
            }
        },
        // beforeRouteLeave (to, from, next) {
        //  var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
        //  if(dialogData && dialogData.length){

        //      if(this.backButtonPress){
        //          dialogjs.fn_checkAndCloseOpenDialogs(this);
        //          next(false);
        //      }
        //      else{
        //          // this.$root.fn_deleteFormObject();
        //          this.fn_saveDraft(this.Form.name);
        //          next(true);
        //      }
        //  }
        //  else{
        //      // if(this.askToDiscard){
        //      //  this.fn_openDialogDiscard();
        //      //  next(false);
        //      // }
        //      if(this.fn_showDialogDiscard()){
        //          this.fn_openDialogDiscard();
        //          next(false);
        //      }
        //      else{
        //          this.fn_clearData(null, function(){
        //              next();
        //          })
        //      }
        //      // if(this.loadedFromDraft || (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId))))){
        //      //  this.fn_openDialogDiscard();
        //      //  next(false);
        //      // }
        //      // else{
        //      //  this.$root.fn_deleteFormObject(this.formId);
        //      //  !this.askToDiscard ? this.fn_removeDraft(this.draftStorageId, null, -1) : '';
        //      //  next(); 
        //      // }
                
        //  }
     //    }
    }

</script>